import { ContentDelete } from '@fs/zion-icon'
import { Button, DialogOverlay, DialogOverlayActions, Paragraph, TextField, useOverlay, IconButton } from '@fs/zion-ui'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { deleteTopicTag } from '../../../services/artifactService'
import useNotifications from '../../../hooks/useNotifications'

const DeleteTopicTagButton = ({ topicTag, topicTagId, refetch }) => {
  const [t] = useTranslation()
  const [idConfirmation, setIdConfirmation] = useState('')
  const confirmDialogOpener = useOverlay()
  const { error } = useNotifications()
  const focusElementRef = useRef()

  const deleteBtnOnSubmit = () => {
    deleteTopicTag(topicTagId)
      .then(() => {
        confirmDialogOpener.close()
        refetch()
      })
      .catch((err) => {
        error(t('artifacts.error.errorDeletingTopicTag', 'Error deleting topic tag'), err)
        confirmDialogOpener.close()
        refetch()
      })
  }

  return (
    <>
      <IconButton Icon={ContentDelete} color="red" onClick={confirmDialogOpener.handleClick} />
      {/* <DangerButton Icon={ContentDelete} onClick={confirmDialogOpener.handleClick}>
    {t('action.delete', 'Delete')}
  </DangerButton> */}
      <DialogOverlay
        focusRef={focusElementRef}
        title={t('artifacts.topicTags.delete', 'Delete Topic Tag')}
        {...confirmDialogOpener}
      >
        <Paragraph size="sm">
          {t(
            'artifacts.topicTags.deleteConfirmation',
            'Are you sure you want to permanently delete the topic tag "{topicTag}"?  This will completely remove the topic tag from the entire system and from all artifacts currently using it.',
            {
              topicTag,
            }
          )}
        </Paragraph>
        <Paragraph size="sm">
          {`${t('artifacts.topicTags.nameConfirmation', 'Please type in the topic tag to confirm.')} "${topicTag}"`}
        </Paragraph>
        <TextField
          ref={focusElementRef}
          id="deleteTopicTagInput"
          label={t('artifacts.topicTag', 'Topic Tag')}
          value={idConfirmation}
          onChange={(e) => setIdConfirmation(e.target.value)}
          type="text"
          fullwidth="true"
        />
        <DialogOverlayActions>
          <Button onClick={deleteBtnOnSubmit} emphasis="high" disabled={idConfirmation !== topicTag}>
            {t('action.submit', 'Submit')}
          </Button>
          <Button onClick={confirmDialogOpener.close}>{t('action.cancel', 'Cancel')}</Button>
        </DialogOverlayActions>
      </DialogOverlay>
    </>
  )
}

export default DeleteTopicTagButton
